/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Jan Černý",
  title: "Hi, I'm Jan!",
  subTitle1: emoji("Junior Software and Web developer 💻"),
  subTitle2: emoji("Graphic designer 🎨"),
  subTitle3: emoji("IT enthusiast ❤️ and biker 🏍️"),
  resumeLink: "https://www.linkedin.com/in/jan-cerny-2001"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/thewest123",
  linkedin: "https://www.linkedin.com/in/jan-cerny-2001/",
  gmail: "info@jancerny.dev",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta"
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "What do I do?",
  subTitle: "Still learning and exploring new things, having experiences in these",
  skills: [
    emoji("⚡ Developing interactive Web apps using Vue.js and Nette, learning React"),
    emoji("⚡ Programming modern C# .NET applications in WPF"),
    emoji("⚡ Trying and learning new things, interested in growth 🚀")
  ],

  /* Make Sure You include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "VueJS",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "C# .NET",
      fontAwesomeClassname: "fas fa-code"
    },{
      skillName: "Git",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "SASS",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Photoshop",
      fontAwesomeClassname: "fab fa-adobe"
    },
    {
      skillName: "Networking",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [{
      Stack: "Programming (C#, Java, Python)", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Web development (VueJS, Nette)",
      progressPercentage: "90%"
    },
    {
      Stack: "Graphic Design",
      progressPercentage: "80%"
    }
  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: false, //Set it to true to show workExperiences Section
  experience: [{
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "thewest123", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "false" // Set true or false to show Contact profile using Github, defaults to false 
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [{
      image: require("./assets/images/saayaHealthLogo.webp"),
      link: "http://saayahealth.com/"
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      link: "http://nextu.se/"
    }
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done!",

  achivementsCards: [{
      title: "MOS World Championship Participant",
      subtitle: "Czech Republic's Representant at the Microsoft Office Specialist World Championship.",
      image: require("./assets/images/mos-championship-logo.png"),
      footerLink: [{
          name: "Certification Badge",
          url: "https://www.youracclaim.com/badges/57b77bbf-82c2-40b6-9005-f7267ec7bee9/"
        }
      ]
    },
    {
      title: "Cisco CCNA Routing and Switching",
      subtitle: "Designing and managing computer networks, configuring routers and switches to provide connectivity for small to medium-sized businesses.",
      image: require("./assets/images/ccna-logo.jpg"),
      footerLink: [{
        name: "View Certification",
        url: "https://jancerny.dev/images/CCNA.jpg"
      }]
    },
    {
      title: "Microsoft Office Specialist",
      subtitle: "Being certified as a Microsoft Office Specialist demonstrates I have advanced skills in all Office programs.",
      image: require("./assets/images/mos-logo.jpg"),
      footerLink: [{
        name: "Word",
        url: "https://www.youracclaim.com/badges/dfddd45d-50b0-4106-9aba-3fb56fcb46f3"
      },
      {
        name: "Excel",
        url: "https://www.youracclaim.com/badges/8c66d310-3bbd-4a4a-8e79-c12cab00d643"
      },
      {
        name: "PowerPoint",
        url: "https://www.youracclaim.com/badges/55c43fdd-ea86-4281-88fa-58bcbb3db5b4"
      },
      {
        name: "Access",
        url: "https://www.youracclaim.com/badges/8b2e3908-6e28-4584-8d97-ef4d58e9eeb0"
      },
      {
        name: "Outlook",
        url: "https://www.youracclaim.com/badges/fea3d664-007f-4b70-b9c6-8f433c3f9e06"
      }]
    },
    {
      title: "AutoCAD 2019 Project",
      subtitle: "Designed and created 2D technical drawing for a school project.",
      image: require("./assets/images/autocad-logo.png"),
      footerLink: [{
        name: "View Certification",
        url: "https://education.autodesk.com/api/Certificate/CertificateDownload/where/AAP%20Project/2019/35/4510754/EM017309577072"
      }]
    }
  ]
};

// Blogs Section

const blogSection = {

  title: "Blogs",
  subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [{
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description: "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ]
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

  talks: [{
    title: "Build Actions For Google Assistant",
    subtitle: "Codelab at GDG DevFest Karachi 2019",
    slides_url: "https://bit.ly/saadpasta-slides",
    event_url: "https://www.facebook.com/events/2339906106275053/"
  }]
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
};

const contactInfo = {
  title: emoji("Contact Me 💡"),
  subtitle: "Just wanna say Hi or discuss a project together?",
  //number: "+92-3243454077",
  email_address: "info@jancerny.dev"
};

//Twitter Section

const twitterDetails = {

  userName: "twitter" //Replace "twitter" with your twitter username without @

};

export {
  greeting,
  socialMediaLinks,
  skillsSection,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};